import styled from 'styled-components';

export const SegmentButtonGroup = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--radius-medium, 8px);
  align-self: stretch;
`;

export const SegmentButton = styled.button<{ isSelected: boolean }>`
  display: flex;
  padding: var(--radius-medium, 8px) var(--radius-large, 16px);
  border-radius: var(--radius-large, 16px);
  justify-content: center;
  align-items: center;
  gap: var(--radius-small, 4px);
  flex: 1 0 0;

  background-color: ${(props) => (props.isSelected ? '#232429' : '#F2F2F7')};
  color: ${(props) => (props.isSelected ? '#FFFFFF' : '#505363')};
  transition: 150ms ease-in-out;

  cursor: pointer;
`;
